"use client";
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useRouter } from "next/navigation";

const Note = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();

  const handleAboutClick = () => {
    setOpen(false);
    router.push("/about");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <div>
          <Button
            variant="outline"
            className="color_red pt-4 pb-3 pl-1.5 pr-1 border-2 text-lg border-dashed border-black sm:hidden rounded-full"
          >
            📝
          </Button>
          <Button className="color_red hidden sm:block rounded-none py-1">
            Read Note 📝
          </Button>
        </div>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-2xl shadow_hand">📝Note</DialogTitle>
        </DialogHeader>
        <div className="neue_machina_regular color_black uppercase">
          <p className="pb-6">
            Behind every tool you see here are hours of{" "}
            <span className="shadow_hand text-lg color_red">
              searching, testing, and love.
            </span>
            <br /> I pour my{" "}
            <span className="shadow_hand text-lg color_red">heart</span> ❤️ into
            finding the best free resources so you don’t have to.
            <br /> If this makes your{" "}
            <span className="shadow_hand text-lg color_red">
              journey easier,
            </span>{" "}
            a small{" "}
            <span className="shadow_hand text-lg color_red">support</span> means
            the world — so please consider keeping{" "}
            <mark className="shadow_hand border border-black text-xl">
              {" "}
              ads enabled😊
            </mark>{" "}
            —it helps keep{" "}
            <span className="shadow_hand text-lg color_red">
              {" "}
              Deep Bucket
            </span>{" "}
            free & growing! 💖
          </p>
          <div className="pb-4 color_red agile border-t-2 border-dashed border-black py-5">
            <button
              onClick={handleAboutClick}
              className="text-center underline underline-offset-2"
            >
              About Us
            </button>
          </div>
          <div className="capitalize spacing">
            <a
              className="agile underline underline-offset-4 mt-1 block"
              href="mailto:the3minutedive@gmail.com"
            >
              Email: the3minutedive@gmail.com
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Note;
